<template>
  <a-drawer :title="title" width="60%" :visible="visible" :body-style="{ paddingBottom: '80px' }" @close="hide">
    <a-spin :spinning="loading">
      <div class="drawer-content">
        <a-descriptions title="基本信息" :column="2" bordered>
          <a-descriptions-item label="文章编号">{{ detailData.id || '-' }}</a-descriptions-item>
          <a-descriptions-item label="文章标题">{{ detailData.title || '-' }}</a-descriptions-item>
          <a-descriptions-item label="文章短标题">{{ detailData.shortTitle || '-' }}</a-descriptions-item>
          <a-descriptions-item label="文章分类">{{ detailData.className || '-' }}</a-descriptions-item>
          <a-descriptions-item label="文章作者">{{ detailData.author || '-' }}</a-descriptions-item>
          <a-descriptions-item label="推荐状态">
            <a-tag :color="detailData.recommend === 1 ? 'green' : 'blue'">
              {{ detailData.recommend === 1 ? '推荐' : '未推荐' }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="文章排序">{{ detailData.sort || 0 }}</a-descriptions-item>
          <a-descriptions-item label="创建时间">{{ formatTime(detailData.createTime) || '-' }}</a-descriptions-item>
          <a-descriptions-item label="文章标题图片" span="2" v-if="detailData.image">
            <img
              :src="getImageUrl(detailData.image)"
              alt="文章标题图片"
              style="
                max-width: 300px;
                max-height: 200px;
                object-fit: cover;
                border: 1px solid #d9d9d9;
                border-radius: 4px;
              "
              @error="handleImageError"
            />
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="统计信息" :column="2" bordered style="margin-top: 16px">
          <a-descriptions-item label="文章点击量">
            <span class="stat-text">{{ detailData.click || 0 }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="文章点赞">
            <span class="stat-text">{{ detailData.dz || 0 }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="文章评论数">
            <span class="stat-text">{{ detailData.commentCount || 0 }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="文章分享数">
            <span class="stat-text">{{ detailData.shareCount || 0 }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="发布时间">{{ formatTime(detailData.publicTime) || '-' }}</a-descriptions-item>
          <a-descriptions-item label="最新评论时间">{{
            formatTime(detailData.lastCommentTime) || '-'
          }}</a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="文章正文" :column="1" bordered style="margin-top: 16px" v-if="detailData.content">
          <a-descriptions-item>
            <div class="content-wrapper" v-html="detailData.content"></div>
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="文章附件" :column="1" bordered style="margin-top: 16px" v-if="detailData.attachmentPath">
          <a-descriptions-item>
            <a :href="$url + detailData.attachmentPath" target="_blank" download>
              <a-icon type="paper-clip" /> 下载附件
            </a>
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="备注信息" :column="1" bordered style="margin-top: 16px">
          <a-descriptions-item label="备注">{{ detailData.remark || '无备注' }}</a-descriptions-item>
        </a-descriptions>
      </div>
    </a-spin>

    <div class="drawer-footer">
      <a-button @click="hide">关闭</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getArticle } from '@/api/tutorial/article'
import { message } from 'ant-design-vue'

export default {
  name: 'DetailDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      detailData: {},
      defaultImage: require('@/assets/images/defaultImg.png'),
    }
  },
  computed: {
    title() {
      return '文章详情'
    },
  },
  methods: {
    show(record) {
      this.visible = true
      this.loadDetail(record.id)
    },
    hide() {
      this.visible = false
      this.detailData = {}
    },
    async loadDetail(id) {
      this.loading = true
      try {
        const response = await getArticle(id)
        if (response && (response.code === '20001' || response.success)) {
          this.detailData = response.data || {}
        } else {
          message.error(response.message || '获取详情失败')
        }
      } catch (error) {
        console.error('获取详情失败:', error)
        message.error('获取详情失败')
      } finally {
        this.loading = false
      }
    },
    formatTime(time) {
      if (!time) return '-'
      return new Date(time).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
    },
    getImageUrl(fileUrl) {
      if (!fileUrl || fileUrl.trim() === '') {
        return this.defaultImage
      }
      return fileUrl.startsWith('http') ? fileUrl : this.$url + fileUrl
    },
    handleImageError(event) {
      event.target.src = this.defaultImage
    },
  },
}
</script>

<style scoped>
.drawer-content {
  padding: 0;
}

.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.stat-text {
  font-weight: 600;
  color: #1890ff;
}

.content-wrapper {
  max-height: 400px;
  overflow-y: auto;
  word-wrap: break-word;
}

.ant-descriptions {
  margin-bottom: 0;
}
</style>
